import MaskedInput from 'react-text-mask';

import styled from 'styled-components';

const handlePadding = (size) => {
  switch (size) {
    case 'small':
      return '0 7px';
    case 'middle':
      return '4px 11px';
    case 'large':
      return '6.5px 11px';
    default:
      return '4px 11px';
  }
};

const Input = styled(MaskedInput)`
  width: 100%;
  padding: ${({ size }) => handlePadding(size)};
  font-size: ${({ size }) => (size === 'large' ? '1rem' : '0.875rem')};
  color: rgba(0, 0, 0, 0.65);
  border: 1px solid #d9d9d9;
  border-radius: 2px;

  &:hover,
  &:focus {
    border-color: #40a9ff;
    outline: 0;
  }

  ::placeholder,
  ::-ms-input-placeholder {
    color: rgba(0, 0, 0, 0.45);
  }
`;

export default { Input };
